import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

type DuplicateEnhancedTaggingRuleAlertProps = Readonly<{
  ruleId: string;
}>;

/** Inline warning when Then-step tag + conditions match an existing rule. */
export default function DuplicateEnhancedTaggingRuleAlert({
  ruleId,
}: DuplicateEnhancedTaggingRuleAlertProps) {
  const displayId = ruleId.trim() || "existing";

  return (
    <Box
      role="alert"
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.25,
        bgcolor: "#FFF1F0",
        border: "1px solid #FFCCC7",
        borderRadius: "8px",
        px: 1.75,
        py: 1.5,
        mb: 2,
      }}
    >
      <WarningAmberRoundedIcon
        sx={{ fontSize: 22, color: "#FAAD14", mt: "1px", flexShrink: 0 }}
      />
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            color: "#CF1322",
            lineHeight: 1.4,
            mb: 0.5,
          }}
        >
          Duplicate Rule Detected
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            color: "#595959",
            lineHeight: 1.5,
          }}
        >
          A rule with the same conditions and tag already exists (Rule{" "}
          {displayId}). Please modify the conditions or tag to create a unique
          rule.
        </Typography>
      </Box>
    </Box>
  );
}
